export default {
  upload: {
    dropFiles: 'Suelta los archivos aquí para subirlos',
    delete: 'Eliminar',
    deleteAllConfirm: '¿Estás seguro de que deseas eliminar todos los archivos?',
    deleteConfirm: '¿Estás seguro de que deseas eliminar {filename}?',
    deleteAllSuccess: '¡Todos los archivos eliminados con éxito!',
    deleteSuccess: '¡{filename} eliminado con éxito!',
    deleteCancelled: 'Eliminación cancelada',
    warning: 'Advertencia',
    cancel: 'Cancelar',
    fileSize: 'Tamaño: {size} KB'
  },
  menu: {
    home: 'Inicio',
    welcome: 'Bienvenido',
    login: 'Iniciar sesión',
    about: 'Sobre nosotros',
    excelEntryManager: 'Gestor de entradas Excel',
    irrigationDashboard: {
      title: 'Panel de Irrigación'
    },
    appleVarieties: {
      title: 'Variedades de Manzana',
      gala: 'Manzanas Gala',
      fuji: 'Manzanas Fuji'
    },
    colheita: 'Cosecha',
    payloads: 'Payloads',
    map: 'Mapa de la Granja',
    farmonaut: {
      title: 'Farmonaut',
      plantations: 'Plantaciones',
      fields: 'Campos',
      upload: 'Subir campo',
      uploadFile: 'Subir archivo',
      autoFix: 'Subir Auto-Fix',
      validate: 'Validar GeoJSON',
      transform: 'Transformar',
      comparison: 'Comparación',
      assignment: 'Asignación',
      createFarmonautFields: 'Crear campos Farmonaut',
      health: 'Comprobación de estado'
    },
    playground: {
      title: 'Playground',
      table: 'Tabla',
      datatable: 'Datatable',
      upload: 'Subir',
      fibuInputChange: 'Fibu Input Change',
      segmented: 'Segmentado',
      timeline: 'Timeline',
      setor: 'Setor',
      sampleUsage: 'Sample Usage',
      createPlantation: 'Crear plantación'
    },
    tests: {
      title: 'Pruebas',
      i18n: 'Prueba I18n'
    },
    test: {
      title: 'Test',
      formily: 'Formily Test'
    }
  },
  test: {
    title: 'Vista de prueba de i18n',
    description: 'Esta es una vista de prueba para demostrar las capacidades de i18n.',
    item1: 'Primer elemento',
    item2: 'Segundo elemento',
    item3: 'Tercer elemento'
  },
  footer: {
    copyright: '© {year} Varena Agropecuaria Ltda. Todos los derechos reservados.'
  },
  table: {
    mdthisIsASwalAlert: 'Esta es una alerta de Swal. Modo: {mode} - URL: {url}'
  },
  appleFarm: {
    title: 'Bienvenido a la Granja de Manzanas Varena',
    about: 'Ubicada en el corazón de Campos em Cima da Serra, Rio Grande do Sul, Brasil. Varena Agropecuria ha sido una granja familiar durante más de 30 años. Nuestro compromiso es con las mejores prácticas agrícolas y la producción de manzanas de la más alta calidad.',
    apples: 'En Varena, cultivamos una variedad de manzanas para todos los gustos. Tenemos diferentes tipos de manzanas, como Gala y Fuji.',
  },
  fujiApples: {
    title: 'Todo sobre las Manzanas Fuji',
    intro: 'Aquí está todo lo que necesitas saber sobre las dulces manzanas Fuji.',
    tips: {
      tip1: 'Las manzanas Fuji son una variedad relativamente nueva. Se cultivaron por primera vez en Japón a finales de la década de 1930, pero no llegaron al mercado mundial hasta 1962.',
      tip2: 'Son el resultado de un cruce exitoso entre dos variedades americanas, Red Delicious y Virginia Ralls Janet.',
      tip3: 'Conocidas por su dulzura, las manzanas Fuji tienen uno de los contenidos de azúcar más altos del mercado, con aproximadamente 14g de azúcar por 100g.',
      tip4: 'Haz las manzanas Fuji dulces aún más dulces usándolas en jaleas y té.',
      tip5: 'Se conservan durante tres meses en el refrigerador. Separa las manzanas dañadas para mantener las otras más frescas por más tiempo.',
      tip6: 'La piel de manzana es una buena fuente de pectina, una forma de fibra soluble. La pectina puede ayudar a reducir el colesterol y los niveles de azúcar en sangre.',
      tip7: '¿Antojo de un bocadillo nocturno? Una manzana es una excelente opción ya que tiene un bajo índice glucémico y está llena de fibra.',
      tip8: 'Para evitar que las manzanas cortadas se pongan marrones, sumérgelas en una mezcla de 1 cucharada de jugo de limón y 1 taza de agua.',
      tip9: 'Las manzanas Fuji frescas y crujientes están en su punto máximo de dulzura y jugosidad entre abril y octubre.',
      tip10: 'Agrega manzanas Fuji finamente cortadas a ensaladas, cereales y ensalada de col para dar frescura y crujiente.'
    },
    funFacts: {
      title: 'Datos Curiosos',
      fact1: 'Muchos piensan que las manzanas Fuji reciben su nombre del Monte Fuji, pero el nombre proviene de Fujisaki, la ciudad japonesa donde se desarrollaron.',
      fact2: 'Una Fuji grande puede proporcionarte el 15 por ciento de tu vitamina C diaria.',
      fact3: 'Las Fuji son una de las mejores manzanas para congelar.',
      fact4: 'Las Fuji son excelentes para rellenar y asar, ya que mantienen su forma al cocinarlas.'
    },
    reference: 'Fuente: taste.com.au'
  },
  galaApples: {
    title: 'Todo sobre las Manzanas Gala',
    intro: 'Aquí hay 7 datos que probablemente no sabías sobre las Manzanas Gala.',
    facts: {
      fact1: {
        title: 'Origen',
        content: 'La Manzana Gala es una antigua variedad procedente de Greytown, Nueva Zelanda, y es una selección realizada por JH Kidd del cruce entre «Kidss Orange» y «Golden Delicious». Es la variedad con mayor producción en el estado de Washington.'
      },
      fact2: {
        title: 'Uso Principal',
        content: 'Con respecto a otras variedades, la Manzana Gala potencializa su toque dulce al ser cocinada. Por esta razón, se recomienda comer en crudo, o bien, cocinar postres dulces como una tarta al horno.'
      },
      fact3: {
        title: 'Demanda Mundial',
        content: 'Es una de las variedades más plantadas a nivel mundial, gracias a su sabor, a su pulpa jugosa y crujiente, buen equilibrio entre azúcares y acidez.'
      },
      fact4: {
        title: 'Dulzor y Sabor',
        content: 'Posee un dulzor equilibrado y con un pequeño toque de acidez, con notas de lima, té blanco y grosellas. Es una manzana carnosa.'
      },
      fact5: {
        title: 'Fácil Consumo',
        content: 'No manchan y no se deshacen, son el snack ideal para consumir en cualquier lugar, ya sea después de las comidas o cuando has olvidado tu cepillo de dientes.'
      },
      fact6: {
        title: 'Hidratación',
        content: 'Son muy refrescantes y nos hidratan casi sin percatarnos, son perfectas para mantenernos frescos a todos los niveles, físico e intelectual.'
      },
      fact7: {
        title: 'Aporte de Energía',
        content: 'La Manzana Gala cuenta con un alto contenido en vitaminas y minerales, así como hidratos de carbono (especialmente en forma de fructosa), que resulta más fácil de absorber por el organismo.'
      }
    },
    reference: 'Fuente: manzanaswashington.com'
  }, excel: {
    edit: {
      title: 'Editar entrada'
    },
    actions: {
      edit: 'Editar',
      viewHistory: 'Ver Historial'
    },
    fields: {
      id: 'ID',
      date: 'Fecha',
      value: 'Valor',
      description: 'Descripción',
      lastModified: 'Última modificación',
      newDescription: 'Nueva Descripción',
      existingDescription: 'Descripción Existente',
      selectDescription: 'Seleccione una descripción'
    }, 
    history: {
      title: 'Historial - {descricao}',
      chartTitle: 'Histórico - {timeGrouping}',
      detailed: 'Detallado',
      monthly: 'Mensual',
      yearly: 'Anual'
    },
    browser: {
      title: "Historial de Descripción",
      selectTitle: "Seleccionar Descripción",
      selectMode: "Modo de Selección",
      viewHistory: "Ver Historial"
    }
  },
  common: {
    save: 'Guardar cambios',
    cancel: 'Cancelar',
    backToList: 'Volver a la lista',
    delete: 'Eliminar'
  },
  valve: {
    stopped: 'Cerrado',
    running: 'Abierto',
    start: 'Iniciar',
    stop: 'Detener',
    title: 'Válvulas',
    name: 'Válvula',
    title_valves: 'Válvulas'

  },  
  colheita: {
    title: 'Entrada de Cantidad de Bins',
    select_date: 'Seleccionar fecha',
    select_setor: 'Seleccionar setor',
    select_type: 'Seleccionar tipo',
    setor: 'Setor',
    gala: 'Gala',
    fuji: 'Fuji',
    quantity: 'Cantidad',
    add_entry: 'Agregar entrada',
    review_submit: 'Revisar y enviar',
    entry: 'Entrada',
    date: 'Fecha',
    type: 'Tipo',
    review_title: 'Revisar entradas',
    submit: 'Enviar',
    cancel: 'Cancelar',
    success: 'Éxito',
    error: 'Error',
    submit_success: 'Entradas enviadas con éxito',
    submit_error: 'Error al enviar las entradas',
    validation_error: 'Por favor, complete todos los campos correctamente antes de enviar',
    load_existing_entries: 'Cargar entradas existentes',
    filter: 'Filtrar por setor o tipo',
    sector: 'Setor',
    variety: 'Variedad',
    total: 'Total'
  }, 
  irrigation: {
    title: 'Panel de Riego',
    valve: 'Válvula',
    state: 'Estado',
    control: 'Control',
    start: 'Iniciar',
    stop: 'Detener',
    name: 'Nombre',
    last_changed: 'Última modificación',
    last_changed_by: 'Última modificación por'
  },
  farmonaut: {
    geoJsonEditor: {
      label: 'Geometría GeoJSON',
      hint: 'Formato polígono: [[[lon, lat], [lon, lat], ...]]',
      valid: 'GeoJSON válido'
    },
    cropCode: {
      label: 'Código de cultivo',
      selectPlaceholder: '-- Seleccionar código de cultivo --',
      manualLabel: 'O ingresar manualmente',
      manualPlaceholder: 'p.ej. 35, 165',
      notInList: 'Código no en la lista permitida (se validará al enviar)'
    },
    response: {
      copy: 'Copiar',
      error: 'Error',
      failed: 'Fallido',
      invalid: 'Inválido',
      success: 'Éxito',
      validResult: 'Válido',
      response: 'Respuesta'
    },
    fieldMap: {
      title: 'Mapa de campo (OpenLayers)'
    },
    plantations: {
      title: 'Cargar datos de plantación',
      loadActive: 'Cargar plantaciones activas',
      loading: 'Cargando...',
      selectPlantation: 'Seleccionar plantación',
      selectPlaceholder: '-- Seleccionar plantación --',
      details: 'Detalles de plantación',
      plantationId: 'ID de plantación',
      area: 'Área',
      anoPlantado: 'Año de plantación',
      anoFinal: 'Año final',
      active: 'Activo',
      farmonautId: 'ID Farmonaut',
      registered: 'Registrado',
      notRegistered: 'No registrado',
      setorDetails: 'Detalles del sector',
      setorId: 'ID del sector',
      setorName: 'Nombre del sector',
      name: 'Nombre',
      setorArea: 'Área del sector',
      center: 'Centro',
      hasGeoJSON: 'Tiene GeoJSON',
      yes: 'Sí',
      loadingFarmonaut: 'Cargando datos de campo Farmonaut...',
      farmonautFieldData: 'Datos de campo Farmonaut',
      farmonautData: 'Datos de campo Farmonaut',
      cropCode: 'Código de cultivo',
      copy: 'Copiar',
      copyCropCode: 'Copiar',
      fieldId: 'ID del campo',
      fieldName: 'Nombre del campo',
      fieldArea: 'Área del campo',
      paymentType: 'Tipo de pago',
      sowingDate: 'Fecha de siembra',
      expired: 'Expirado',
      paused: 'Pausado',
      fullJson: 'Respuesta JSON completa',
      showJson: 'Mostrar JSON completo',
      hideJson: 'Ocultar JSON',
      clickToLoad: 'Haga clic en "Cargar plantaciones activas" para obtener plantaciones del backend.',
      errorFarmonaut: 'Error al cargar datos de Farmonaut',
      sendToFarmonaut: 'Enviar a Farmonaut (Auto-Fix)',
      useInForms: 'Usar en formularios',
      infoMessage: 'Haga clic en "Cargar plantaciones activas" para obtener plantaciones del backend.',
      noGeoJson: 'La plantación seleccionada no tiene datos GeoJSON en su sector'
    },
    fields: {
      title: 'Cargar campo Farmonaut por ID',
      description: 'Seleccione un ID de campo Farmonaut para cargar y mostrar datos del campo.',
      fieldIdLabel: 'ID de campo Farmonaut',
      selectField: 'ID de campo Farmonaut',
      selectPlaceholder: '-- Seleccionar campo --',
      loadingFieldIds: 'Cargando IDs de campo...',
      errorFieldIds: 'Error al cargar IDs de campo',
      loadField: 'Cargar campo',
      reset: 'Restablecer',
      cropCodeSection: 'Código de cultivo',
      copyCropCode: 'Copiar código de cultivo',
      fieldDetails: 'Detalles del campo',
      fieldId: 'ID del campo',
      fieldName: 'Nombre del campo',
      fieldArea: 'Área del campo',
      centerCoordinates: 'Coordenadas del centro',
      paymentType: 'Tipo de pago',
      sowingDate: 'Fecha de siembra',
      fieldStatus: 'Estado del campo',
      expired: 'Expirado',
      expiring: 'Expirando',
      paused: 'Pausado',
      paid: 'Pagado',
      healthData: 'Datos de salud',
      healthIndicatorLabel: 'Indicador',
      healthIndicatorPlaceholder: 'Seleccione indicador',
      viewGraph: 'Gráfico',
      viewTable: 'Tabla',
      dateColumn: 'Fecha',
      valueColumn: 'Valor',
      rawJson: 'JSON crudo',
      syncToInternal: 'Sincronizar a BD interna',
      syncToInternalSuccess: 'Sincronización completada. Intentos: {attempted}, Omitidos: {skipped}, Errores: {errors}',
      syncErrorNoPlantation: 'Ninguna plantación vinculada a este campo Farmonaut.',
      updateAllIndices: 'Actualizar todos los índices Farmonaut en la BD',
      updateAllIndicesSuccess: 'Importación completada. Procesados: {processed}, Correctos: {success}, Errores: {errors}',
      updateAllIndicesError: 'Error al actualizar los índices.',
      weatherData: 'Datos meteorológicos',
      yieldData: 'Datos de rendimiento',
      coordinates: 'Coordenadas',
      sensedDays: 'Días detectados'
    },
    upload: {
      title: 'Subir campo',
      fieldName: 'Nombre del campo',
      address: 'Dirección',
      farmerId: 'ID del agricultor',
      submit: 'Subir campo',
      uploading: 'Subiendo...',
      reset: 'Restablecer'
    },
    fileUpload: {
      title: 'Subir archivo GeoJSON',
      fieldName: 'Nombre del campo',
      geoJsonFile: 'Archivo GeoJSON',
      selectFile: 'Seleccione un archivo .geojson o .json',
      submit: 'Subir archivo',
      uploading: 'Subiendo...',
      reset: 'Restablecer'
    },
    autoFix: {
      title: 'Subir con Auto-Fix',
      description: 'Sube un campo y repara automáticamente problemas comunes de GeoJSON (LineString a Polygon, cierre de anillo, etc.)',
      fieldName: 'Nombre del campo',
      address: 'Dirección',
      farmerId: 'ID del agricultor',
      hint: 'Las geometrías LineString se convertirán automáticamente en Polygon',
      submit: 'Subir con Auto-Fix',
      uploading: 'Subiendo...',
      reset: 'Restablecer',
      repairedGeoJson: 'GeoJSON reparado'
    },
    validate: {
      title: 'Validar GeoJSON',
      description: 'Validar GeoJSON sin subir a Farmonaut',
      fieldName: 'Nombre del campo',
      cropCode: 'Código de cultivo',
      address: 'Dirección',
      farmerId: 'ID del agricultor',
      submit: 'Validar',
      validating: 'Validando...',
      reset: 'Restablecer'
    },
    transform: {
      title: 'Convertir a formato Farmonaut',
      description: 'Convierte GeoJSON al formato Farmonaut sin subirlo. Muestra la estructura de datos transformada.',
      fieldName: 'Nombre del campo',
      address: 'Dirección',
      farmerId: 'ID del agricultor',
      submit: 'Transformar',
      transforming: 'Transformando...',
      reset: 'Restablecer',
      transformedGeoJson: 'GeoJSON transformado (formato Farmonaut)',
      copyToClipboard: 'Copiar al portapapeles',
      copied: '¡Copiado!'
    },
    comparison: {
      title: 'Comparación de campo y plantación',
      description: 'Compare datos de campo Farmonaut con datos de plantación en un solo mapa',
      farmonautFieldId: 'ID de campo Farmonaut',
      selectFieldPlaceholder: '-- Seleccionar campo (opcional) --',
      selectPlantation: 'Seleccionar plantación',
      selectPlantationPlaceholder: '-- Seleccionar plantación --',
      loadPlantations: 'Cargar plantaciones',
      loadField: 'Cargar campo Farmonaut',
      loadFarmonautField: 'Cargar campo Farmonaut',
      loadPlantation: 'Cargar plantación',
      loadComparison: 'Cargar comparación',
      reset: 'Restablecer',
      farmonautField: 'Campo Farmonaut (Azul)',
      farmonautFieldBlue: 'Campo Farmonaut (Azul)',
      plantation: 'Plantación (Verde)',
      plantationGreen: 'Plantación (Verde)',
      plantationId: 'ID de plantación',
      setorName: 'Nombre del sector',
      fieldId: 'ID del campo',
      fieldName: 'Nombre del campo',
      area: 'Área',
      cropCode: 'Código de cultivo',
      farmonautId: 'ID Farmonaut',
      notRegistered: 'No registrado',
      assignFarmonautId: 'Asignar ID Farmonaut',
      assigning: 'Asignando...',
      comparisonMap: 'Mapa de comparación',
      legendFarmonaut: 'Campo Farmonaut',
      legendPlantation: 'Plantación',
      loadingData: 'Cargando datos...',
      loadingFieldIds: 'Cargando IDs de campo...',
      farmonautFieldError: 'Error en campo Farmonaut',
      plantationError: 'Error en plantación',
      assignmentError: 'Error en asignación'
    },
    validation: {
      description: 'Validar GeoJSON sin subir a Farmonaut',
      fieldName: 'Nombre del campo',
      fieldNamePlaceholder: 'Introduzca el nombre del campo',
      cropCode: 'Código de cultivo',
      cropCodePlaceholder: 'p.ej. 35, 165',
      cropCodeHint: 'El código se validará al enviar',
      address: 'Dirección',
      addressPlaceholder: 'Dirección opcional',
      farmerId: 'ID del agricultor',
      farmerIdPlaceholder: 'ID del agricultor opcional',
      validate: 'Validar',
      reset: 'Restablecer'
    },
    createFarmonaut: {
      title: 'Crear campos Farmonaut desde plantaciones',
      description: 'Seleccione plantaciones sin ID Farmonaut y cree nuevos campos Farmonaut a partir de sus datos GeoJSON.',
      loading: 'Cargando...',
      refresh: 'Actualizar plantaciones',
      withoutId: '{count} plantación(es) sin ID Farmonaut',
      noPlantations: 'No se encontraron plantaciones sin ID Farmonaut.',
      allLinked: 'Todas las plantaciones activas han sido vinculadas a campos Farmonaut.',
      plantation: 'Plantación',
      created: 'Creado',
      creating: 'Creando...',
      error: 'Error',
      plantationDetails: 'Detalles de la plantación',
      geojsonPreview: 'Vista previa GeoJSON',
      createField: 'Crear campo Farmonaut',
      createButton: 'Crear campo Farmonaut',
      successTitle: '¡Campo Farmonaut creado con éxito!',
      fieldId: 'ID del campo Farmonaut',
      linked: 'La plantación ha sido vinculada a este campo Farmonaut.',
      transformDetails: 'Ver detalles de transformación',
      noGeojson: 'No – No se puede crear campo Farmonaut',
      noGeojsonAlert: 'La plantación seleccionada no tiene datos GeoJSON en su sector.',
      noDesignacao: 'El sector de la plantación no tiene nombre (designación). No se puede crear campo Farmonaut.',
      confirmTitle: '¿Crear campo Farmonaut?',
      confirmMessage: '¿Crear campo Farmonaut para la Plantación {id}? Sector: {name}, Código de cultivo: {cropCode}. Esto creará un nuevo campo Farmonaut y lo vinculará a esta plantación.'
    },
    assignment: {
      title: 'Asignación de campo y plantación',
      description: 'Asigne IDs de campo Farmonaut a plantaciones. Cada campo tiene su propio mapa para comparación visual.',
      loadingSummaries: 'Cargando resúmenes de campos y plantaciones...',
      noFields: 'No se encontraron campos Farmonaut.',
      fieldId: 'ID del campo',
      assignedTo: 'Asignado a plantación {id}',
      notAssigned: 'No asignado',
      selectPlantation: '-- Seleccionar plantación --',
      assign: 'Asignar',
      assigning: 'Asignando...',
      successAssigned: '¡Asignado con éxito!',
      loadingMap: 'Cargando datos del mapa...'
    },
    health: {
      title: 'Comprobación de estado',
      checkHealth: 'Comprobar estado',
      checking: 'Comprobando...',
      infoMessage: 'Haga clic en "Comprobar estado" para verificar si el servicio Farmonaut está funcionando.'
    },
    common: {
      loading: 'Cargando...',
      error: 'Error',
      noData: 'N/D',
      yes: 'Sí',
      setor: 'Sector',
      plantation: 'Plantación',
      area: 'Área',
      planted: 'Plantado'
    }
  },
  createPlantation: {
    title: 'Crear nueva plantación',
    setor: 'Setor',
    selectSetor: '-- Seleccionar setor --',
    subtipo: 'Subtipo',
    selectSubtipo: '-- Seleccionar subtipo --',
    filas: 'Filas',
    arvores: 'Árvores',
    optionalFields: 'Campos opcionales',
    area: 'Área (ha)',
    plantasPorHa: 'Plantas por Ha',
    anoPlantado: 'Año plantado',
    anoFinal: 'Año final',
    origem: 'Origen',
    custoPlantacao: 'Costo plantación',
    formaTreinamento: 'Forma treinamento',
    cobertura: 'Cobertura',
    submit: 'Crear plantación',
    creating: 'Creando...',
    reset: 'Restablecer',
    activeWarning: 'Este setor ya tiene una plantación activa. No puede crear una nueva.',
    success: '¡Plantación creada con éxito! ID: {id}',
    errorActive: 'No se puede crear plantación: el setor ya tiene una plantación activa',
    errorGeneric: 'Error al crear plantación'
  }
} 